import { UserClaims } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';

interface AppServicesToken {
    id_token: string;
    access_token: string;
    user_claims: UserClaims;
}

// Determine if the user is logged in
// The user may have logged in either using the app services login or the on-page login
export function useIsLoggedIn(): boolean
 {
    const { authState, oktaAuth } = useOktaAuth();
    return authState?.isAuthenticated || oktaAuth?.getAccessToken() != null;
};

export function useGetAppServicesToken(): AppServicesToken
{
    const { authState, oktaAuth } = useOktaAuth();
    return {
        id_token: oktaAuth?.getIdToken() as string,
        access_token: oktaAuth?.getAccessToken() as string,
        user_claims: authState?.idToken?.claims as UserClaims || {}
    };
};

export function useGetToken(): string
{
    return useGetAppServicesToken()?.access_token;
};
